import { defineComponent as _defineComponent } from 'vue'
import VueTelInputVuetify from "../../plugins/telephone/vue-tel-input-vuetify.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'DropdownTelephone',
  props: {
    disabled: { type: Boolean },
    error: { type: Boolean }
  },
  setup(__props: any) {



return { __sfc: true,VueTelInputVuetify }
}

})